import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { offerings } from '../../data/home';
import { fadeUp } from '../../utils/motion';
export function HomeOfferings() {
  return <section id="what-we-build" className="bg-white py-20 lg:py-28 scroll-mt-20" data-id="element-823" data-mp="151fmmdo71yvu">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-824" data-mp="110c39h6xtkpv">
        <motion.h2 {...fadeUp} className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight mb-14" data-id="element-825" data-mp="10z145uoft153">
          What we build
        </motion.h2>

        <div className="border-b border-line" data-id="element-826" data-mp="8adb3cxg57gz">
          {offerings.map(item => <motion.article key={item.id} {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 border-t border-line py-12" data-id="element-827" data-mp="m5phwiovmoe9">
              <div className="lg:col-span-4" data-id="element-828" data-mp="3pqlg1001ge5r">
                <p className="text-sm font-medium text-teal mb-3" data-id="element-829" data-mp="3lrmbhgi7yjeu">{item.tag}</p>
                <h3 className="font-heading font-bold text-2xl lg:text-3xl text-ink-dark leading-snug" data-id="element-830" data-mp="2umk54lw3rw93">
                  {item.title}
                </h3>
              </div>
              <div className="lg:col-span-8" data-id="element-831" data-mp="2zjk64ie3i8tc">
                <p className="text-lg text-ink-muted leading-relaxed" data-id="element-832" data-mp="34c3k3ggp35yo">{item.body}</p>
                {item.example && <p className="mt-6 bg-surface-muted rounded-lg p-6 text-base text-ink-dark leading-relaxed" data-id="element-833" data-mp="39a55w95i9jdu">
                    {item.example}
                  </p>}
                <a href={item.link} className="mt-6 inline-flex items-center gap-2 text-navy font-semibold hover:text-teal transition-colors duration-150" data-id="element-834" data-mp="2gnu5ayhwfih1">
                  {item.linkLabel}
                  <ArrowRight size={16} data-id="element-835" data-mp="2qivwdzvqium9" />
                </a>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}